// src/components/ClientNotFound.mjs
import React from 'react';

const ClientNotFound = () => {
    return (
        <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100vh',
            flexDirection: 'column',
            backgroundColor: '#f0e9fd',
            fontFamily: 'Arial, sans-serif'
        }}>
            <div style={{
                textAlign: 'center',
                padding: '2rem',
                backgroundColor: 'white',
                borderRadius: '8px',
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                maxWidth: '400px'
            }}>
                <h1 style={{ 
                    color: '#d32f2f', 
                    marginBottom: '1rem',
                    fontSize: '1.5rem'
                }}>
                    Cliente não encontrado
                </h1>
                <p style={{ 
                    color: '#666', 
                    marginBottom: '1.5rem',
                    lineHeight: '1.5'
                }}>
                    Verifique se o nome do cliente está correto na URL.
                </p>
                <div style={{
                    fontSize: '0.9rem',
                    color: '#888',
                    fontStyle: 'italic'
                }}>
                    Exemplo: localhost/raquel
                </div>
            </div>
        </div>
    );
};

export default ClientNotFound;
